import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Table } from "reactstrap";
import { authAsUser } from "services/api";

export const AuthAsUser = ({ customer, setLoading }) => {

  const authAsUserHandler = (id) => {
    setLoading(true);
    authAsUser({ id })
      .then((res) => {
        window.open(`https://lk.lider-truck.ru/login?accessToken=${res.accessToken}&refreshToken=${res.refreshToken}`, '_blank', 'noopener,noreferrer');
      })
      .catch((e) => {
        toast.error(
          e.response?.data?.message || "Ошибка"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const renderAccountsTable = () => {
    if (customer?.users?.length < 1) {
      return null;
    }

    return <Table className="table-hover authAsUser">
      <tbody>
        {customer?.users.map(item =>
          <tr key={item.id}>
            <td>{item.title || 'Default'}</td>
            <td><Button onClick={() => authAsUserHandler(item.id)}>Авторизоваться под клиентом</Button></td>
          </tr>
        )}
      </tbody>
    </Table >
  };

  return (
    <>
      <Card
        className="main-form"
      >
        <CardBody>
          {renderAccountsTable()}
        </CardBody>
      </Card >
    </>
  )

}